/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { Badge, Button, Tooltip } from "@mui/material";
import objectPath from "object-path";
import React, { useEffect, useMemo, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { WORK_FLOW_TYPE } from "../../../../app/config/cacheKey";
import {
  Cartable,
  CartableNotification,
} from "../../../../app/models/cartable.model";
import { cartableSet } from "../../../../app/redux/activeCartable/activeCartableSlice";
import { getJwtToken } from "../../../../app/services/auth.service";
import { GetCartableNotification } from "../../../../app/services/cartable.service";
import { isTokenExpired } from "../../../../app/utility/isTokenExpired";
import { DropdownTopbarItemToggler } from "../../../_partials/dropdowns";
import { useHtmlClassService } from "../../_core/MetronicLayout";

export function QuickCartableSummaryDropDown(refreshQuickCartable: any) {
  const uiService = useHtmlClassService();
  const [cartable, setCartable] = useState<Cartable[]>();
  const [cartableTotalCount, setCartableTotalCount] = useState(0);

  const dispatch = useDispatch();
  const history = useHistory();
  const queryClient = useQueryClient();
  const token = getJwtToken();
  const handleClick = (item: any) => {
    dispatch(cartableSet({ cartable: item.cartableName }));
    localStorage.setItem("setActivePage", `${item.cartableName}`);
    queryClient.setQueryData(WORK_FLOW_TYPE, item.cartableName);
    history.push({
      pathname: `/loan/${item.cartableName}`,
      state: { refetchStatus: true },
      // search: "test",
    });
  };

  const jsonFile = useSelector((state: any) => state.style);

  const layoutProps = useMemo(() => {
    return {
      light:
        objectPath.get(uiService.config, "extras.user.dropdown.style") ===
        "light",
    };
  }, [uiService]);

  const getCartableNotification = useMutation(GetCartableNotification, {
    onSuccess: (data: CartableNotification) => {
      setCartable(data.cartables);
      setCartableTotalCount(data.totalCount);
    },
  });

  const MINUTE_MS = 15 * 60 * 1000;

  useEffect(() => {
    if (!isTokenExpired(token)) {
      const interval = setInterval(() => {
        getCartableNotification.mutate();
        //getCartables()
      }, MINUTE_MS);

      return () => clearInterval(interval);
    }
  }, []);

  useEffect(() => {
    if (
      refreshQuickCartable != undefined &&
      refreshQuickCartable.refreshQuickCartable &&
      !isTokenExpired(token)
    ) {
      getCartableNotification.mutate();
    }
  }, [refreshQuickCartable]);

  useEffect(() => {
    if (!isTokenExpired(token)) {
      getCartableNotification.mutate();
    }
  }, []);
  if (getCartableNotification?.isLoading) {
    return <></>;
  }

  const repeatCallService = () => {
    getCartableNotification.mutate();
  };

  return (
    <Dropdown drop='down' alignRight>
      <Dropdown.Toggle
        as={DropdownTopbarItemToggler}
        id='dropdown-toggle-user-profile'
      >
        <div
          className={
            "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 divDrop1 marginLeft-10 "
          }
        >
          {cartableTotalCount != 0 ? (
            <>
              <Tooltip title='کارتابل'>
                <Badge
                  color={jsonFile?.badgeColor}
                  sx={{
                    "&.MuiBadge-badge": {
                      fontWeight: "bold",
                      fontSize: "14px !important",
                      direction: "ltr",
                    },
                  }}
                  badgeContent={
                    cartableTotalCount > 99 ? "+99" : cartableTotalCount
                  }
                >
                  <WorkOutlineIcon className='Icons BorderColor ' />
                </Badge>
              </Tooltip>
            </>
          ) : (
            <WorkOutlineIcon className='Icons BorderColor ' />
          )}
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu
        className='p-0 m-0 dropdown-menu-right dropd
      own-menu-anim dropdown-menu-top-unround dropdown-menu-xl divDrop'
      >
        <>
          {cartableTotalCount != 0 ? (
            cartable?.map((item: any, i: number) => (
              <div className='navi navi-spacer-x-0 '>
                {i === cartable.length ? (
                  <></>
                ) : (
                  <div className='navi-separator '></div>
                )}

                <div
                  className='navi-footer  px-8 py-5 cursorPointer '
                  style={{ marginRight: "10px" }}
                  onClick={() => handleClick(item)}
                >
                  <div style={{ float: "right" }}>
                    <Button
                      style={{ color: "#fff", fontSize: "12px" }}
                      className=' font-weight-bold colorFFF textFont11 cursorPointer'
                    >
                      {item.title}
                    </Button>
                  </div>
                  <div style={{ float: "left" }}>
                    <Badge
                      sx={{ "&.MuiBadge-badge": { fontWeight: "bold" } }}
                      badgeContent={item.count > 99 ? "+99" : item.count}
                      className='badgeStyle cursorPointer'
                    />
                  </div>
                </div>
              </div>
            ))
          ) : (
            <></>
          )}
        </>
      </Dropdown.Menu>
    </Dropdown>
  );
}

const TOKEN_KEY = "token";
const handelToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.setItem("setActivePage", "Wellcome");
};
